import React from 'react';
import cIf from 'classnames';
import { getMomentTZDateTime } from 'ts-util';

import type { ETicketDisplay } from '../../../tsrestapi/models';

import TranslatorManager from 'ts-translate-js';
const tr = TranslatorManager.boundTR;

type ETicketDisplayPaging = ETicketDisplay & {
    Numbering: string
}

interface ETicketMobileDisplayProps {
    eticketDisplay: ETicketDisplayPaging
}

interface ETicketMobileDisplayState {
    showDisplayShareLink: boolean
}

export class ETicketMobileDisplay extends React.Component<ETicketMobileDisplayProps, ETicketMobileDisplayState> {
    displayName = "ETicketMobileDisplay";

    constructor(props: ETicketMobileDisplayProps) {
        super(props);
        this.state = {
            showDisplayShareLink: false
        };
    }

    getReasonText(passState) {
        if (passState.deactivatedReason === 'REISSUED') {
            if (passState.deactivatedNote.toLowerCase().includes('réimpression'))
                return tr('Billet réimprimé');
            else 
                return tr('Billet remplacé');
        }
        else if (passState.deactivatedReason === 'BLOCKED') return tr('Billet bloqué');
        return tr('Billet désactivé');
    }

    render(){
        const src = "https://billetterie.reservatech.net/adminnet/QRCode/" + this.props.eticketDisplay.PassNumber + "/12";
        let ticketName = this.props.eticketDisplay.SeatName;

        // Si on a une TicketDateOverride alors on remplace le seatname par le date override
        if (this.props.eticketDisplay.TicketDateOverride !== null){
            ticketName = getMomentTZDateTime(this.props.eticketDisplay.TicketDateOverride, this.props.eticketDisplay.TZDatabaseID).format(tsapp.tr("program.format.moment.datetime"));
        }

        const ticketState = this.props.eticketDisplay.TicketState;

        return (
            <div className="container">
                <br/>
                <div className="well col-xs-12 col-sm-8 col-md-6 col-lg-6 col-sm-offset-2 col-md-offset-3 eticketContainer">
                    <div className="row mobile-spacing">
                        <div className="col-xs-4">{this.props.eticketDisplay.AuthCode}</div>
                        <div className="col-xs-4"></div>
                        <div className="col-xs-4"><span className="pull-right">{this.props.eticketDisplay.Numbering}</span></div>
                    </div>
                    <div className="row eticketMobileWithSpacing">{this.props.eticketDisplay.EventName}</div>
                    <div className="row eticketMobile">{this.props.eticketDisplay.VenueName}</div>

                    { 
                        this.props.eticketDisplay.ShouldDisplayEventDate && <div className="row eticketMobileWithSpacing">
                            <strong>
                                {getMomentTZDateTime(this.props.eticketDisplay.EventDate, this.props.eticketDisplay.TZDatabaseID).format(tsapp.tr("program.format.moment.datetime"))}
                            </strong>
                        </div>
                    }

                    <div className={cIf(["row eticketMobileWithSpacing", {"deactivated": !ticketState.isActivated}])}><img className="eticketMobileQR" src={src} alt=""></img></div>
                    <div className={cIf(["row eticketMobile passnumber", {"deactivated": !ticketState.isActivated}])}><span className='smaller-text'>{this.props.eticketDisplay.PassNumber}</span></div>
                    <div className={cIf(["row eticketMobileWithSpacing", {"deactivated": !ticketState.isActivated}])}><strong>{ticketName}</strong></div>
                    <div className={cIf(["row eticketMobileWithSpacing", {"deactivated": !ticketState.isActivated}])}><strong>{this.props.eticketDisplay.PricegroupLetter}</strong><span className='smaller-text'>{this.props.eticketDisplay.PricegroupName}</span></div>

                    {
                        !ticketState.isActivated && <div className="row eticketMobileWithSpacing alert alert-danger">
                            <strong>
                                {tr('Invalide - {reason}', {reason: this.getReasonText(ticketState)})}
                            </strong> 
                            <span className="smaller-text">({tr('le {date}', {date: getMomentTZDateTime(ticketState.stateDate, this.props.eticketDisplay.TZDatabaseID).format("DD MMMM yyyy hh:mm:ss")})})</span>
                        </div>
                    }
                </div>
            </div>
        );
    }
}